import {Injectable} from '@angular/core';
import {DataCoreService, DlistDto} from '@dabnet-kamu/libs/ui';
import {BehaviorSubject} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ControlConditionModel} from "../../../models/gen-control.model";
@Injectable()
export class IkaPersonelService {
  public isActivePersonel!: boolean;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
  public isActiveDate!: string;
  public rolAd!: string;
  public controlCondition: ControlConditionModel[];
  customQuery: string;
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsList$ = this._gridControlsList.asObservable();
  constructor(private dataCoreService: DataCoreService, private _httpClient: HttpClient) {
  }
  setParams(isActivePersonel: boolean, isActiveDate: string, rolAd: string, controlCondition?: ControlConditionModel[],customQuery?:string, isReadOnly? : boolean, isBindCheck? : boolean ) {
    this.isActivePersonel = isActivePersonel;
    this.isReadOnly = isReadOnly;
    this.isBindCheck = isBindCheck;
    this.isActiveDate = isActiveDate;
    this.rolAd = rolAd;
    this.controlCondition = controlCondition;
    this.customQuery = customQuery
  }
  private baseEntity1: string | undefined;
  getData(code: number, control: any, isActivePersonel: boolean, isActiveDate: string, rolAd: string, baseEntity?: string,customQuery?:string, isSetData?: boolean) {
    this.baseEntity1 = baseEntity;
    let tableName = this.baseEntity1;
    let query = "";
     let dataSource: any;
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
    } 
    else{
      if (isActivePersonel) query = query + "AktifEh=E"
      if (rolAd?.length) {
        if (query.length > 0) query = query + "&";
        query = query + "RolAd=" + rolAd;
      }
      if (isActiveDate.length > 0) {
        if (query.length > 0) query = query + "&";
        query = query + "AktifTarih=" + isActiveDate;
      }
      if (customQuery?.length > 0) {
        if(query.length > 0) query = query + "&";
        query = query + customQuery;
      }
      if (query.length > 0) tableName = tableName + "?" + query;
      dataSource = this.dataCoreService.getOData(tableName);
    } 





    dataSource.select([]);
    const filterArr = [];
    if (code) filterArr.push([control.kodField, '=', code]);
    if (filterArr.length > 0) dataSource.filter(filterArr)
    return dataSource;
  }
}









